const dashboard = () => import('../views/sale/dashboard.vue')
const orderIndex = () => import('../views/sale/orders/index.vue')
const orderShow = () => import('../views/sale/orders/show.vue')
export default [
    {
        path: '/sale/dashboard',
        component: dashboard,
        name: 'moduleDashboard',
        meta: {
            module_name: 'sale',
        }
    },
    {
        path: '/sale/orders',
        component: orderIndex,
        meta: {
            module_name: 'sale',
            en_name: "saleOrder",
            auth_id: 81101
        }
    },
    {
        path: '/sale/orders/:id',
        component: orderShow,
        meta: {
            module_name: 'sale',
            en_name: "saleOrder",
            auth_id: 81105
        }
    }
]
